import { createAction } from '@reduxjs/toolkit';
import { FileType } from 'commons/constants/type';
import { HandleDownload } from 'commons/framework/aws/type';
import { PaginationType } from 'commons/framework/type';
import { PreviewParamProps } from 'pages/type';

/**
 * model
 */
import AssetVO from 'commons/vo/AssetVO';
import AssetParamVO from 'commons/vo/param/AssetParamVO';
import QuarterVO from 'commons/vo/QuarterVO';
import TeamVO from 'commons/vo/TeamVO';

import {
  REQUEST_ASSET_LIST,
  REQUEST_ASSET_LIST_SUCCESS,
  REQUEST_ASSET_LIST_FAILURE,
  SET_QUARTER_LIST,
  REQUEST_INTERVIEW_DOWNLOAD_CLOUDFRONT,
  REQUEST_INTERVIEW_DOWNLOAD_CLOUDFRONT_SUCCESS,
  REQUEST_INTERVIEW_DOWNLOAD_CLOUDFRONT_FAILURE,
  REQUEST_HIGHLIGHT_DOWNLOAD_CLOUDFRONT,
  REQUEST_HIGHLIGHT_DOWNLOAD_CLOUDFRONT_SUCCESS,
  REQUEST_HIGHLIGHT_DOWNLOAD_CLOUDFRONT_FAILURE,
} from './types';
import { REQUEST_ASSET, REQUEST_ASSET_SUCCESS, REQUEST_ASSET_FAILURE } from './types';

import {
  REQUEST_ASSET_DOWNLOAD,
  REQUEST_ASSET_DOWNLOAD_SUCCESS,
  REQUEST_ASSET_DOWNLOAD_FAILURE,
} from './types';

import {
  REQUEST_ASSET_DOWNLOAD_S3,
  REQUEST_ASSET_DOWNLOAD_S3_SUCCESS,
  REQUEST_ASSET_DOWNLOAD_S3_FAILURE,
} from './types';

import {
  REQUEST_ASSET_DOWNLOAD_S3_FROM_WEB_SERVER,
  REQUEST_ASSET_DOWNLOAD_S3_FROM_WEB_SERVER_SUCCESS,
  REQUEST_ASSET_DOWNLOAD_S3_FROM_WEB_SERVER_FAILURE,
} from './types';

import {
  REQUEST_ASSET_DOWNLOAD_CLOUDFRONT,
  REQUEST_ASSET_DOWNLOAD_CLOUDFRONT_SUCCESS,
  REQUEST_ASSET_DOWNLOAD_CLOUDFRONT_FAILURE,
} from './types';

import { SELECT_QUARTER } from './types';
import WkblVideoVO from 'commons/vo/WkblVideoVO';

/**
 * * 에셋 조회
 */
export const requestAssetList = createAction<{ param: AssetParamVO }, typeof REQUEST_ASSET_LIST>(
  REQUEST_ASSET_LIST,
);
export const requestAssetListSuccess = createAction<
  { assetList: AssetVO[]; pagination: PaginationType },
  typeof REQUEST_ASSET_LIST_SUCCESS
>(REQUEST_ASSET_LIST_SUCCESS);
export const requestAssetListFailure = createAction(REQUEST_ASSET_LIST_FAILURE);

export const requestAsset = createAction<{ params: PreviewParamProps }, typeof REQUEST_ASSET>(
  REQUEST_ASSET,
);
export const requestAssetSuccess = createAction<
  {
    asset: AssetVO;
    quarterList: QuarterVO[];
    teamList: TeamVO[];
    selectedQuarter: QuarterVO | null;
  },
  typeof REQUEST_ASSET_SUCCESS
>(REQUEST_ASSET_SUCCESS);
export const requestAssetFailure = createAction(REQUEST_ASSET_FAILURE);

/**
 * * 에셋 다운로드
 */
export const requestAssetDownload = createAction<
  { videoId: number; storageId: number; type: FileType },
  typeof REQUEST_ASSET_DOWNLOAD
>(REQUEST_ASSET_DOWNLOAD);
export const requestAssetDownloadSuccess = createAction<
  { asset: AssetVO },
  typeof REQUEST_ASSET_DOWNLOAD_SUCCESS
>(REQUEST_ASSET_DOWNLOAD_SUCCESS);
export const requestAssetDownloadFailure = createAction(REQUEST_ASSET_DOWNLOAD_FAILURE);

/**
 * * 에셋 S3 다운로드
 */

export const requestAssetDownloadS3 = createAction<
  { id: number },
  typeof REQUEST_ASSET_DOWNLOAD_S3
>(REQUEST_ASSET_DOWNLOAD_S3);
export const requestAssetDownloadS3Success = createAction(REQUEST_ASSET_DOWNLOAD_S3_SUCCESS);
export const requestAssetDownloadS3Failure = createAction(REQUEST_ASSET_DOWNLOAD_S3_FAILURE);

/**
 * * 에셋 S3 > Web server 다운로드
 */
export const requestAssetDownloadS3FromWebServer = createAction<
  { id: number; title: string; filePath: string; handleDownload: HandleDownload },
  typeof REQUEST_ASSET_DOWNLOAD_S3_FROM_WEB_SERVER
>(REQUEST_ASSET_DOWNLOAD_S3_FROM_WEB_SERVER);
export const requestAssetDownloadS3FromWebServerSuccess = createAction(
  REQUEST_ASSET_DOWNLOAD_S3_FROM_WEB_SERVER_SUCCESS,
);
export const requestAssetDownloadS3FromWebServerFailure = createAction(
  REQUEST_ASSET_DOWNLOAD_S3_FROM_WEB_SERVER_FAILURE,
);

/**
 * * 에셋 Cloudfront 다운로드
 */

export const requestAssetDownloadCloudfront = createAction<
  { categoryId: number; fileName: string; downloadFileName: string; },
  typeof REQUEST_ASSET_DOWNLOAD_CLOUDFRONT
>(REQUEST_ASSET_DOWNLOAD_CLOUDFRONT);
export const requestAssetDownloadCloudfrontSuccess = createAction<
  { categoryId: number; fileName: string; downloadFileName: string; },
  typeof REQUEST_ASSET_DOWNLOAD_CLOUDFRONT_SUCCESS
>(REQUEST_ASSET_DOWNLOAD_CLOUDFRONT_SUCCESS);
export const requestAssetDownloadCloudfrontFailure = createAction(
  REQUEST_ASSET_DOWNLOAD_CLOUDFRONT_FAILURE,
);

/**
 * * 시스템 자동 부분인출(인터뷰, 하이라이트) Cloudfront 다운로드
 */

export const requestInterviewDownloadCloudfront = createAction<
  { downloadUrl: string; },
  typeof REQUEST_INTERVIEW_DOWNLOAD_CLOUDFRONT
>(REQUEST_INTERVIEW_DOWNLOAD_CLOUDFRONT);
export const requestInterviewDownloadCloudfrontSuccess = createAction<
  { downloadUrl: string; },
  typeof REQUEST_INTERVIEW_DOWNLOAD_CLOUDFRONT_SUCCESS
>(REQUEST_INTERVIEW_DOWNLOAD_CLOUDFRONT_SUCCESS);
export const requestInterviewDownloadCloudfrontFailure = createAction(
  REQUEST_INTERVIEW_DOWNLOAD_CLOUDFRONT_FAILURE,
);

export const requestHighlightDownloadCloudfront = createAction<
  { downloadUrl: string; },
  typeof REQUEST_HIGHLIGHT_DOWNLOAD_CLOUDFRONT
>(REQUEST_HIGHLIGHT_DOWNLOAD_CLOUDFRONT);
export const requestHighlightDownloadCloudfrontSuccess = createAction<
  { downloadUrl: string; },
  typeof REQUEST_HIGHLIGHT_DOWNLOAD_CLOUDFRONT_SUCCESS
>(REQUEST_HIGHLIGHT_DOWNLOAD_CLOUDFRONT_SUCCESS);
export const requestHighlightDownloadCloudfrontFailure = createAction(
  REQUEST_HIGHLIGHT_DOWNLOAD_CLOUDFRONT_FAILURE,
);

/**
 * * 경기 쿼터 선택
 */
export const selectQuarter = createAction<{ quarter: QuarterVO | null }, typeof SELECT_QUARTER>(
  SELECT_QUARTER,
);

/**
 * * 쿼터리스트 셋팅
 */
  export const setQuarterList = createAction<{ quarterList: QuarterVO[] }, typeof SET_QUARTER_LIST>(
    SET_QUARTER_LIST,
  );
